import NotInformation from '../../../../../components/NotInformation';
import DocumentationHistoryTabApp from "../Functionality/DocumentationHistoryTabApp";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const DocumentationHistoryTab = ({ id, historyModel, containerClass, historyRef, notInformationClass='', noInformationTitle }) => {
   const { t, data, getCards, pagination } = DocumentationHistoryTabApp({
       id,
       historyModel,
       historyRef
   })

    return (
        <>
            {data?.content?.length === 0 ? (
                <NotInformation
                   text={t(noInformationTitle)}
                    card={true}
                    className={notInformationClass}
                />
            ) : (
                <>
                    <div className={"col-12 pb-3"}>
                        <p className='justify-content-start d-flex ibl-font-w-400 fs-14px ibl-font-w-600'>
                            {t('grouped_by_date')}
                        </p>
                    </div>

                    <div ref={historyRef} className={`overflow-y-auto col-12 ${containerClass}`}>
                        { getCards()}
                    </div>
                    { pagination() }
                </>
            )}
        </>
    );
};

export default DocumentationHistoryTab;
